module.exports = __webpack_public_path__ + "thumb-up-100.png";


//////////////////
// WEBPACK FOOTER
// ../shared-components/src/assets/images/thumb-up-100.png
// module id = 812
// module chunks = 0